// extracted by mini-css-extract-plugin
export var icon = "_b9-3";
export var subtitle = "_b9-2";
export var title = "_b9-1";
export var value = "_b9-0";